import { openURL } from 'quasar'
import firebase from "firebase"

export default {
   name: 'LayoutDefault',
   data() {
      return {
         leftDrawerOpen: this.$q.platform.is.desktop
      }
   },
   methods: {
      openURL,
      logout() {
         firebase.auth().signOut().then(() => {
            this.$router.replace('login')
         })
      }
   }
}
